import {LIST_SALE_REPORTS, FETCH_SALE_REPORTS, CLEAR_SALE_REPORTS} from "./types";

const init = {
    isLoading: true,
    data: {
        items: [],
        summary: null,
    },
    filter: {},
    page: 1,
    totals: 0,
    size: 50
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_SALE_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_SALE_REPORTS:
            return {
                ...state,
                isLoading: false,
                ...payload
            };
        case CLEAR_SALE_REPORTS:
            return {
                isLoading: false,
                data: {
                    items: [],
                    summary: null,
                },
                page: 1,
                totals: 0,
                size: 50
            };
        default:
            return state;
    }
}